import React from "react";
import {Input, InputNumber, Typography} from "antd"

const {Text} = Typography

export default class TextDataField extends React.Component {
    render() {

        const {edit, propertie, value, onChange} = this.props

        var Component = Input
        if (propertie.startsWith("[NUMBER]_")) {
            Component = InputNumber
        }

        if (!edit) {
            return <Text>{value}</Text>
        }


        return (
            <Component
                style={{width: "100%"}}
                defaultValue={value}
                onChange={(e) => {
                    let v = e
                    if (e?.target?.value) {
                        v = e.target.value
                    }
                    onChange(v)
                }}
            />
        )
    }
}
